import { useState } from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { es } from "date-fns/locale";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

function parseIsoDate(value) {
  if (!value) return undefined;
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return undefined;
  return new Date(year, month - 1, day);
}

function formatIsoDate(date) {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

function humanize(value) {
  const date = parseIsoDate(value);
  if (!date) return "Elegir fecha";
  return `${date.getDate()} de ${monthNames[date.getMonth()]} de ${date.getFullYear()}`;
}

export default function DatePickerField({ value, onChange, placeholder = "Elegir fecha", testId, disabled, allowClear = false }) {
  const [open, setOpen] = useState(false);
  const selected = parseIsoDate(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          disabled={disabled}
          className="date-picker-trigger"
        >
          <CalendarIcon size={16} />
          <span>{value ? humanize(value) : placeholder}</span>
          {allowClear && value && (
            <span
              role="button"
              tabIndex={0}
              data-testid={testId ? `${testId}-clear` : undefined}
              onClick={(event) => {
                event.stopPropagation();
                onChange("");
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  event.stopPropagation();
                  onChange("");
                }
              }}
              className="date-picker-clear"
            >
              ×
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="date-picker-content">
        <Calendar
          mode="single"
          locale={es}
          selected={selected}
          onSelect={(date) => {
            onChange(date ? formatIsoDate(date) : "");
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
